// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._4bp0yZ8yx{flex-direction:column;justify-content:center;min-height:100%;flex-grow:1;text-align:center}._2tiLummIx,.JcROAdmtx{margin-bottom:20px;width:200px;height:auto}html[data-supports-mobile=true] ._2tiLummIx{margin-bottom:16px;width:120px;height:auto}@media (max-width: 767px){html[data-supports-mobile=true] ._2tiLummIx{width:80px}}@media (max-width: 767px){html[data-supports-mobile=true] .JcROAdmtx{margin-bottom:16px;width:120px;height:auto}}@media (max-width: 767px){html[data-supports-mobile=true] ._2hrEHMsEx{margin-bottom:16px;width:240px;height:auto}}._4wsTC0zZx{display:flex;flex-direction:row;justify-content:center;align-items:center}._4wsTC0zZx>*{margin-left:6px;margin-right:6px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"empty-state": "_4bp0yZ8yx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"emptyState": "_4bp0yZ8yx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"regular-image": "_2tiLummIx",
	"regularImage": "_2tiLummIx",
	"large-image": "JcROAdmtx",
	"largeImage": "JcROAdmtx",
	"huge-image": "_2hrEHMsEx",
	"hugeImage": "_2hrEHMsEx",
	"button-row": "_4wsTC0zZx",
	"buttonRow": "_4wsTC0zZx"
};
module.exports = exports;
